var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('LoadingContainer'):_c('div',[_c('FormPanel',{attrs:{"initial":_vm.contentFile.attributes,"headline":"Edit File","errors":_vm.errors,"company-id":_vm.contentFile.attributes.company_id,"content-file-categories":_vm.contentFileCategories,"edit":true},on:{"submit":_vm.submit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }